import { render, staticRenderFns } from "./SquareMetersPriceChartType.vue?vue&type=template&id=be3e49ea&scoped=true&"
import script from "./SquareMetersPriceChartType.vue?vue&type=script&lang=js&"
export * from "./SquareMetersPriceChartType.vue?vue&type=script&lang=js&"
import style0 from "./SquareMetersPriceChartType.vue?vue&type=style&index=0&id=be3e49ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3e49ea",
  null
  
)

export default component.exports